import { Button, Header } from "@/presentation/components";
import { DataTable, DataTableColumn } from "@/presentation/components/common/DataTable";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { useEquipo } from "@/presentation/hooks/useEquipo";
import { routes } from "@/presentation/router";
import { formatStateE } from "@/shared";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import './IncidentePage.css';
import { useSimple } from "@/presentation/hooks/useSimple";
import { useCongrupo } from "@/presentation/hooks/useCongrupo";
import { EquipoParamsDTO } from "@/application";
import { CreateDialog } from "../action/components/CreateActionDialog";
import { Form } from "@/presentation/components/Forms/Form/Form";

export default function EquiposPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const {
    data: equipos,
    loading,
    error,
    loadAll: getEquipos,
  } = useEquipo();
  const [openFilters, setOpenFilters] = useState(false)
  const {
    data: grupos,
    reload: loadGrupos,
  } = useSimple('luc_ubicaciones_grupo');
  const {
    data: tipos,
    reload: loadTipos,
  } = useSimple('luc_tipo_equipo');
  const {
    data: ubicaciones,
    loadByGroup,
  } = useCongrupo();
  const grupoOptions = useMemo(
    () =>
      grupos.map((grupo) => ({
        value: grupo.id,
        label: grupo.nombre,
      })),
    [grupos]
  );

  const ubicacionOptions = useMemo(
    () =>
      ubicaciones.map((ubicacion) => ({
        value: ubicacion.id,
        label: ubicacion.nombre,
      })),
    [ubicaciones]
  );
  const tipoOptions = useMemo(
    () =>
      tipos.map((tipo) => ({
        value: tipo.id,
        label: tipo.nombre,
      })),
    [tipos]
  );

  const handleFilterClick = async () => {
    await loadGrupos()
    await loadTipos()
    setOpenFilters(true)
  };
  const [params, setParams] =
    useState<EquipoParamsDTO>({
      pages: 1
    });

  

  useEffect(() => {
    getEquipos(params);

  }, [params, getEquipos]);

  const handleFilter = (
    values: EquipoParamsDTO
  ) => {
    setParams((current) => ({
      ...current,
      ...values,
      pages: 1,
      equipo:
        values.equipo?.trim() || undefined,
    }));

    setOpenFilters(false);
  };


  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };

  const columns: DataTableColumn<any>[] = [
    {
      key: 'equipo',
      header: 'Equipo',
    },
    {
      key: 'ubicacion',
      header: 'Ubicación',
    },
    {
      key: 'lote',
      header: 'Lote',
    },
    {
      key: 'tipo',
      header: 'Tipo',
    },
    {
      key: 'estado',
      header: 'Estado',
      render: (value) =>
        formatStateE(value.estado),
    },
  ];

  const nuevoequipo = () => {
    navigate('/equipo/formulario/0', { replace: true });
  };

  

 
  const clearFilters = () => {
    setParams(
      {
        pages: 1
      });
  }

  return (
    <div>
      <Header
        title="Equipos"
        onMenuClick={handleOpenDrawer}
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />

      <main className="incidentes-page">
        <div className="incidentes-page__toolbar">
          <Button
            onClick={clearFilters}
            disabled={loading}
          >
            Borrar Filtros
          </Button>

          <Button
            onClick={handleFilterClick}
            disabled={loading}
          >
            Filtrar
          </Button>
        </div>

        {loading && (
          <p className="incidentes-page__message">
            Cargando incidentes...
          </p>
        )}

        {error && (
          <p className="incidentes-page__error">
            {error}
          </p>
        )}

        {!loading && !error && (
          <DataTable
            columns={columns}
            data={equipos}
            onRowClick={(equipo) =>
              navigate(`/equipo/${equipo.id}`)
            }
            emptyMessage="No hay Equipos cargados"
            page={params.pages ?? 1}
            hasPrevious={(params.pages ?? 1) > 1}
            hasNext={equipos.length === 25}
            onPrevious={() =>
              setParams((current) => ({
                ...current,
                pages: Math.max(
                  1,
                  (current.pages ?? 1) - 1
                ),
              }))
            }
            onNext={() =>
              setParams((current) => ({
                ...current,
                pages: (current.pages ?? 1) + 1,
              }))
            }
          />
        )}
      </main>
      <BottomAppBar
        items={[
          {
            label: 'Nuevo Equipo',
            onClick: nuevoequipo,
            icon: undefined,
          },
        ]}
      />
      <CreateDialog
        open={openFilters}
        title="Filtros"
        onClose={() => setOpenFilters(false)}
      >
        <Form
          fields={[
            {
              name: 'grupo',
              label: 'Grupo',
              type: 'select',
              options: grupoOptions,
              optional:true
            },
            {
              name: 'ubicacion',
              label: 'Ubicación',
              type: 'select',
              options: ubicacionOptions,
              optional:true
            },
            {
              name: 'tipo',
              label: 'Tipo',
              type: 'select',
              options: tipoOptions,
              optional:true
            },
            {
              name: "equipo",
              type: "text",
              label: "Equipo",
              optional:true
            }

          ]}
          onFieldChange={(name, value) => {
            if (name === 'grupo') {
              loadByGroup(
                'luc_ubicaciones',
                String(value)
              );
            }
          }}
          submitLabel="Aceptar"
          onSubmit={handleFilter}
        />
      </CreateDialog>
    </div>
  );
}